/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Col, FormGroup } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import messages from './CompanyName.messages';
import FormField from '../FormField/index';

export default function ManualCompany({ company, toggle }) {
    return (
        <Col className="col-left" sm={6} xs={12}>
            <FormGroup className="sub-form-group">
                <FormField
                    wrapperGrid={{ xs: 12, sm: 6 }}
                    wrapperClassName="col-left"
                    field={company.company_name}
                    label={<FormattedMessage {...messages.companyName} />}
                    labelProps={{ htmlFor: 'company.company_name' }}>
                    <FormField.Input
                        whenBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_company_name'
                                });
                            }
                        }}
                        id="company.company_name"
                        maxLength={200}
                    />
                </FormField>
                <FormField
                    wrapperGrid={{ xs: 12, sm: 6 }}
                    wrapperClassName="col-right"
                    field={company.company_number}
                    label={<FormattedMessage {...messages.companyNumber} />}
                    labelProps={{ htmlFor: 'company.company_number' }}>
                    <FormField.Input
                        whenBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_company_number'
                                });
                            }
                        }}
                        id="company.company_number"
                        maxLength={50}
                    />
                </FormField>
                <Col xs={12}>
                    <div className="toggle-company-link">
                        <a
                            onClick={(event) => {
                                tracking.ampli.companyNameSearchSecondarySelected();
                                toggle(event);
                            }}>
                            <FormattedMessage {...messages.searchForCompany} />
                        </a>
                    </div>
                </Col>
            </FormGroup>
        </Col>
    );
}
